'use strict'

class TakeawaysCarousel {
    constructor() {
        this.carousels = null;
    }

    init() {
        this.carousels = document.querySelectorAll('.takeaways-carousel');
        if (this.carousels.length) this.initCarousels();
    }

    initCarousels() {
        const self = this;

		self.carousels.forEach(function(carousel) {
			const owl = jQuery(carousel);
			const owlPrev = carousel.parentNode.querySelector('.takeaways-carousel-nav-prev');
			const owlNext = carousel.parentNode.querySelector('.takeaways-carousel-nav-next');
			const $dotsContainer = carousel.parentNode.querySelector('.takeaways-carousel-nav-dots');
			owl.owlCarousel({
				nav: false,
				dots: true,
				dotsContainer: $dotsContainer,
				margin: 20,
				responsive: {
					0: {
						items: 1,
					},
					768: {
						items: 1,
					},
					1024: {
						items: 1,
					},
					1440: {
						items: 1,
					}
				}
			});
		});
    }
}
